module.exports = __webpack_public_path__ + "static/media/02_digginglight.394a31fc.jpg";